import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import AppHeader from "../../../components/Header/Header";
import AppLayout from "../../../components/layout";
import Container from 'react-bootstrap/Container';
import Image from 'react-bootstrap/Image';
import Button from 'react-bootstrap/Button';
import Carousel from 'react-bootstrap/Carousel';
import BannerSection from "../../../components/ui/BannerSection";

const noticias = [
  {
    id: 1,
    images: [
      require('../../../assets/Not_14_Capa.jpg'), // Adicione quantas imagens quiser
    ],
    title: 'CURSO PREPARATÓRIO ISPA para acesso Ano Lectivo 2025-2026',
    subtitle: 'Invista em conhecimento, habilidades e oportunidades. ',
    content: 'A Melhor preparação para acesso ao ensino Superior.Nas seguintes áreas: SAÚDE GESTÃO, ENGENHARIA,CIÊNCIAS SOCIAIS. \n\n',
    data: 'Data de início: 23 de Junho a 16 de Julho',
    preco: 'Preço da Inscrições: 5.000kz. \n\n Desconto  para aqueles que  queiram ingressar ao ISPA. \n\n',
    Endereco: 'Localização: Estamos localizados Estrada Lar do Patriota- Rua 14 e em Viana- Via Expressa- Bairro Capalanga \n\n',
    telefone: 'Telefone: 929 282 704, 954 179 562. \n\n',
    video: null
  },
  {
    id: 2,
    images: [
      require('../../../assets/Not_15.jpg'),
      require('../../../assets/Not_15_01.jpg'),
      require('../../../assets/Not_15_02.jpg'),
      require('../../../assets/Not_15_03.jpg'),
    ],
    title: 'Brasil e Angola unidos por laços espirituais e acadêmicos: Visita do Reverendo Sérgio ao ISPA Atlântida',
    subtitle: 'ISPA Atlântida e Instituto Azusa fortalecem laços acadêmicos e espirituais em encontro histórico marcado por homenagens e diálogo construtivo',
    content: 'Em março de 2025, o ISPA Atlântida recebeu a visita institucional do reverendo doutor Sérgio e da comitiva do Instituto Azusa, fortalecendo os laços entre Angola e Brasil nas áreas da educação, psicologia e espiritualidade. A visita incluiu uma receção oficial, um tour pelas instalações e uma cerimônia simbólica de homenagem ao doutor Stanislaus Barros, representado por seu filho Pedro Barros, que recebeu uma medalha de comendador.',
    content2: 'Um dos destaques foi a conferência “Resolvendo Conflitos no Ambiente de Trabalho”, ministrada pela doutora Remilda, que promoveu reflexão e aprendizado entre os profissionais do ISPA. A visita abriu caminhos para futuras parcerias estratégicas, incluindo intercâmbios e programas conjuntos, reafirmando o compromisso do ISPA com a formação ética e transformadora',
    video: null
  },
  {
    id: 3,
    images: [
      require('../../../assets/Not_21.jpg'),
      require('../../../assets/Not_20.jpg'),
      require('../../../assets/Not_17.jpg'),
      require('../../../assets/Not_18.jpg'),
      require('../../../assets/Not_19.jpg'),
 
      

    ],
    title: 'Visita da Secretária de Estado para a Ciência, Tecnologia e Inovação',
    subtitle: 'O objetivo da visita foi conhecer as atividades científicas da instituição, identificar pontos fortes e áreas de melhoria, encorajar investigadores...',
    content: 'A Secretária de Estado para a Ciência, Tecnologia e Inovação, Alice de Ceita e Almeida, liderou uma equipa do Ministério do Ensino Superior, Ciência, Tecnologia e Inovação (MESCTI) numa visita ao Instituto Superior Politécnico Atlântida (ISP-Atlântida) na terça-feira, 1 de julho. O objetivo da visita foi conhecer as atividades científicas da instituição, identificar pontos fortes e áreas de melhoria, encorajar investigadores, incentivar a recolha de indicadores de ciência e tecnologia, e verificar o funcionamento das incubadoras de empresas. O ISP-Atlântida, fundado em 2003 e legalizado em 2012, é vocacionado para o ensino, investigação e prestação de serviços, possuindo unidades orgânicas em Ciências Económicas, Jurídicas e Humanas, Ciências da Saúde e Engenharia.',
    content2: 'Antes da visita às instalações, uma reunião de trabalho revelou que o ISP-Atlântida tem 120 docentes, com 18 dedicados à investigação científica, e dispõe de duas unidades de laboratório de ensino e investigação com 18 investigadores e 10 técnicos. A Secretária de Estado, acompanhada pelo Gestor Principal Eduardo Guilherme Soto, visitou vários laboratórios, incluindo os de enfermagem, ciências económicas, jurídicas e humanas, análises clínicas, e um laboratório multifuncional, além da incubadora de empresas..',
    content3:'No final da visita, Alice de Ceita e Almeida expressou grande satisfação e surpresa com o trabalho desenvolvido pelo ISP-Atlântida. Ela destacou positivamente os laboratórios de apoio à investigação, em particular o laboratório da área da saúde, que considerou bem equipado, e a incubadora de empresas. A Secretária de Estado classificou a visita como muito positiva e manifestou a crença de que o ISP-Atlântida alcançará um patamar superior de crescimento e inovação num futuro próximo.',
    video: null
  },
  {
    id: 4,
    images: [
      require('../../../assets/Not_01.jpg'),
    ],
    title: 'Educação e Formação Científica',
    subtitle: 'A Pesquisa como Caminho para o Conhecimento',
    content: 'A Jornada Científica é um espaço dedicado à promoção do conhecimento, da investigação e da inovação. Nesta seção, os visitantes encontrarão informações completas sobre o evento, incluindo o tema central da edição, a programação das palestras, comunicações orais, apresentações de pôsteres, workshops e mesas-redondas.',
    content2: 'É também o lugar onde serão divulgadas as normas para submissão de trabalhos, as áreas temáticas contempladas, os nomes dos palestrantes convidados, além dos resultados e destaques dos melhores projetos apresentados.',
    video: null
  },
  {
    id: 5,
    images: [
      require('../../../assets/Not_02.jpg'),
    ],
    title: 'Formação de Qualidade para um Futuro Brilhante',
    subtitle: 'Prepare-se para os desafios do mercado de trabalho com a melhor educação.',
    content: 'Prepare-se para os desafios do mercado de trabalho com a melhor educação. Aqui, você encontra o suporte, o conhecimento e as ferramentas necessárias para alcançar grandes conquistas.',
    content2: 'Acreditamos que a educação é a chave para o sucesso e estamos comprometidos em oferecer uma formação de qualidade que prepare nossos alunos para um futuro brilhante. Junte-se a nós e descubra como podemos ajudar você a alcançar seus objetivos profissionais.',
    video: null
  },
  {
    id: 6,
    images: [
      require('../../../assets/Not_03.jpg'),
    ],
    title: 'O Seu Futuro Profissional Merece o Melhor',
    subtitle: 'Com a formação certa, você está a um passo de transformar seus sonhos em realidade.',
    content: 'Com a formação certa, você está a um passo de transformar seus sonhos em realidade. Invista em você, aprenda com os melhores e prepare-se para um futuro de sucesso. Estamos aqui para te ajudar a alcançar o topo.',
    content2: 'Nossa missão é proporcionar uma educação de excelência, com professores qualificados e um ambiente de aprendizado inspirador. Venha fazer parte da nossa comunidade acadêmica e construa um futuro profissional promissor.',
    video: null
  },
  {
    id: 7,
    images: [
      require('../../../assets/Not_05.jpg'),
    ],
    title: 'Palestra  sobre a violencia Domestica',
    subtitle: 'Na palestra sobre a violência doméstica, especialistas e ativistas se reuniram para discutir esse tema crucial.',
    content: 'Na palestra sobre a violência doméstica, realizada em uma data não especificada, especialistas e ativistas se reuniram para discutir esse tema crucial. Durante o evento, foram abordadas questões como prevenção, suporte às vítimas e mudança de paradigmas culturais.',
    content2: 'A palestra contou com a participação de profissionais renomados, que compartilharam suas experiências e conhecimentos sobre o assunto. O objetivo foi sensibilizar a comunidade acadêmica e promover um diálogo construtivo sobre como combater essa problemática social.',
    video: null
  },
  {
    id: 8,
    images: [
      require('../../../assets/Not_06.jpg'),
    ],
    title: 'Lançamento da ROC- Revista Olhar Científico',
    subtitle: 'A Pesquisa como Caminho para o Conhecimento.',
    content: 'No lançamento da ROC - Revista Olhar Científico, um evento marcante ocorrido em uma data específica não fornecida, a comunidade acadêmica se reuniu para celebrar a inauguração desta importante plataforma de divulgação científica.',
    content2: 'A revista tem como objetivo promover a pesquisa e a inovação, oferecendo um espaço para a publicação de artigos científicos, estudos de caso e revisões de literatura. Durante o evento, foram apresentados os primeiros números da revista, destacando a qualidade e relevância dos trabalhos publicados.',
    video: null
  },
  {
    id: 9,
    images: [
      require('../../../assets/Not_08.jpg'),
    ],
    title: 'Batismo dos Caloiros ISPA 2023',
    subtitle: 'No Batismo dos Caloiros do ISPA em 2023, os novos estudantes foram recebidos em uma atmosfera de camaradagem e tradição.',
    content: 'No Batismo dos Caloiros do ISPA em 2023, os novos estudantes foram recebidos em uma atmosfera de camaradagem e tradição. O evento, realizado com entusiasmo pela comunidade acadêmica, incluiu rituais simbólicos e atividades de integração para dar as boas-vindas aos caloiros',
    content2: 'O batismo é uma tradição que visa fortalecer os laços entre os alunos e promover um senso de pertencimento à instituição. Durante a cerimônia, foram realizadas apresentações culturais, discursos inspiradores e momentos de confraternização, celebrando o início de uma nova jornada acadêmica.',
    video: null
  }
];

export default function NoticiaDetalhes() {
  const { id } = useParams();
  const navigate = useNavigate();
  const noticia = noticias.find(n => n.id === parseInt(id));

  if (!noticia) {
    return (
      <div style={{
        minHeight: "80vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        background: "#fff"
      }}>
        <div style={{
          background: "#fff",
          borderRadius: "18px",
          boxShadow: "0 8px 32px rgba(60,60,120,0.12)",
          padding: "48px 32px",
          textAlign: "center",
          animation: "fadeIn 1s"
        }}>
          {/* Animated page icon */}
          <svg
            width="80"
            height="80"
            viewBox="0 0 48 48"
            fill="none"
            style={{ marginBottom: 24, animation: "pageBounce 1.2s infinite" }}
          >
            <rect x="8" y="8" width="32" height="40" rx="6" fill="#6366f1" />
            <rect x="14" y="16" width="20" height="4" rx="2" fill="#fff" />
            <rect x="14" y="24" width="16" height="4" rx="2" fill="#e0e7ff" />
            <rect x="14" y="32" width="12" height="4" rx="2" fill="#e0e7ff" />
            <rect x="8" y="8" width="32" height="8" rx="4" fill="#0ea5e9" />
            <rect x="12" y="10" width="8" height="4" rx="2" fill="#fff" />
          </svg>
          <h2 style={{ marginBottom: 16, color: "#6366f1" }}>Notícia não encontrada</h2>
          <p style={{ marginBottom: 32, color: "#444" }}>
            Ops! A notícia que você procura não existe ou foi removida.<br />
            Volte para a página de notícias e explore outras novidades!
          </p>
          <Button
            variant="primary"
            size="lg"
            style={{
              borderRadius: "24px",
              padding: "12px 36px",
              fontWeight: 600,
              fontSize: "1.1rem",
              boxShadow: "0 2px 8px rgba(99,102,241,0.12)"
            }}
            onClick={() => navigate("/noticia")}
          >
            ← Voltar para Notícias
          </Button>
        </div>
        <style>
          {`
            @keyframes fadeIn {
              from { opacity: 0; transform: translateY(40px);}
              to { opacity: 1; transform: translateY(0);}
            }
            @keyframes pageBounce {
              0%, 100% { transform: translateY(0);}
              50% { transform: translateY(-12px);}
            }
          `}
        </style>
      </div>
    );
  }

  return (
    <div>
      <BannerSection
          title="Notícias"
          subtitle="Acompanhe as últimas atualizações e eventos do ISPA Atlântida"
          description={`Bem-vindo à seção de notícias do ISPA Atlântida, onde você encontra as últimas atualizações, eventos e informações relevantes sobre nossa instituição. Fique por dentro das novidades e acompanhe nosso compromisso com a excelência acadêmica e a inovação.`}
          backgroundImage={require('../../../assets/img2.jpg')}
          backgroundId="instituition-Banner"
      />
      {/* Barra de navegação das noticias*/}
      <div style={{ background: "#f5f6fa", padding: "16px 0 8px 0" }}>
        <Container>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb" style={{ background: "transparent", marginBottom: 0 }}>
              <li className="breadcrumb-item">
                <a href="/" style={{ color: "#00761F", textDecoration: "none" }}>Home</a>
              </li>
              <li className="breadcrumb-item">
                <a href="/noticia" style={{ color: "#00761F", textDecoration: "none" }}>Notícias</a>
              </li>
              <li className="breadcrumb-item active" aria-current="page" style={{ color: "#222" }}>
                {noticia.title}
              </li>
            </ol>
          </nav>
        </Container>
      </div>

      <header id='header'>
        <AppHeader />
      </header>
      <Container style={{ paddingTop: "50px", paddingBottom: "50px" }}>
        <div style={{ display: "flex", flexWrap: "wrap", alignItems: "flex-start", gap: "40px", marginTop: "40px" }}>
          <div style={{ flex: "1 1 350px", minWidth: 0 }}>
            <h2>{noticia.title}</h2>
            <h5 style={{ marginTop: "20px", color:'#000000' }}><b>{noticia.subtitle}</b></h5>
            <p style={{ marginTop: "10px" }}>{noticia.content}</p>
            <p style={{ marginTop: "10px" }}><b>{noticia.data}</b></p>
            <p style={{ marginTop: "10px" }}>{noticia.preco}</p>
            <p style={{ marginTop: "10px" }}>{noticia.Endereco}</p>
            <p style={{ marginTop: "10px" }}>{noticia.telefone}</p>
            <p style={{ marginTop: "10px" }}>{noticia.content2}</p>
            <p style={{ marginTop: "10px" }}>{noticia.content3}</p>
            {noticia.video && (
              <p style={{ marginTop: "10px" }}>
                <b>Vídeo:</b> {noticia.video}
              </p>
            )}
          </div>
          <div style={{ flex: "0 1 600px", display: "flex", flexDirection: "column", justifyContent: "flex-end", gap: "24px" }}>
            {noticia.video && (
              <video
                controls
                style={{ maxHeight: "600px", maxWidth: "100%", borderRadius: "12px", marginBottom: noticia.images?.length ? "16px" : 0 }}
                src={noticia.video}
              >
                Seu navegador não suporta a reprodução de vídeo.
              </video>
            )}
            {noticia.images && noticia.images.length > 1 ? (
              <Carousel style={{ maxHeight: "600px", maxWidth: "100%", borderRadius: "12px", overflow: "hidden" }}>
                {noticia.images.map((img, idx) => (
                  <Carousel.Item key={idx}>
                    <Image src={img} fluid style={{ maxHeight: "600px", maxWidth: "100%", borderRadius: "12px" }} />
                  </Carousel.Item>
                ))}
              </Carousel>
            ) : (
              noticia.images && noticia.images.length === 1 && (
                <Image src={noticia.images[0]} fluid style={{ maxHeight: "600px", maxWidth: "100%", borderRadius: "12px" }} />
              )
            )}
          </div>
        </div>
      </Container>
      <AppLayout />
    </div>
  );
}
